// Action Names
export const PRESENCE_ENTER = "PRESENCE_ENTER";
export const PRESENCE_LEAVE = "PRESENCE_LEAVE";
export const PRESENCE_OVERRIDE = "PRESENCE_OVERRIDE";

// Note: This type is incomplete
export type MemberType = {
    clientId: string;
    connectionId: string;
};

export interface PresenceEnterAction {
    type: typeof PRESENCE_ENTER;
    member: MemberType;
}

export interface PresenceLeaveAction {
    type: typeof PRESENCE_LEAVE;
    member: MemberType;
}

export interface PresenceOverrideAction {
    type: typeof PRESENCE_OVERRIDE;
    members: Array<MemberType>;
    inUse: boolean;
}

export type PresenceActionTypes = PresenceEnterAction | PresenceLeaveAction | PresenceOverrideAction;

export interface PresenceType {
    clientId: string;
    connectionId: string;
    outlet: boolean | string;
    register: boolean | string;
}

export type PresenceState = Array<PresenceType>;

export function enterPresence(member: MemberType): PresenceActionTypes {
    return {
        type: PRESENCE_ENTER,
        member,
    };
}

export function leavePresence(member: MemberType): PresenceActionTypes {
    return {
        type: PRESENCE_LEAVE,
        member,
    };
}

export function overridePresence(members: Array<MemberType>, inUse: boolean): PresenceActionTypes {
    return {
        type: PRESENCE_OVERRIDE,
        members,
        inUse,
    };
}
